import { colors } from '@atlaskit/theme';
import styled from 'styled-components';

// @source
import { theme } from '../../styles';

const QueryBuilder = styled.div`
  margin: 1.25rem 0;
  box-sizing: border-box;
`;

const FieldText = styled.div`
  min-width: 120px;

  input {
    -webkit-text-size-adjust: 82%;
  }

  & > div > label {
    display: none;
  }
`;

const OparatorLabel = styled.div`
  color: ${colors.N400};
  font-size: .75rem;
  display: inline-block;
  vertical-align: middle;
`;

const Oparator = styled.div`
  display: inline-block;
  vertical-align: middle;

  .IconWrapper-sc-1y3jy9j-0 {
    display: none;
  }
`;

const Group = styled.div`
  display: block;
  box-sizing: border-box;

  .sc-sdtwF {
    border-left: 2px solid ${theme.border};
    padding-left: 1rem;
    margin: 4px 0;
  }
`;

const GroupContent = styled.div`
  position: relative;
`;

const Condition = styled.div`
  position: relative;
  display: flex;

  @media (max-width: 666px) {
    display: block;
  }
`;

const Flex = styled.div`
  display: flex;
  align-items: center;
`;

const FlexItem = styled.div`
  flex: ${props => (props.nowrap ? '0' : '1')};
  white-space: ${props => (props.nowrap ? 'nowrap' : 'normal')};
  padding: ${props => (props.nospace ? '0' : '.2rem')};
`;

export default {
  Condition,
  FieldText,
  Flex,
  FlexItem,
  Group,
  GroupContent,
  Oparator,
  OparatorLabel,
  QueryBuilder,
};
